import { render, staticRenderFns } from "./KnowingUs.vue?vue&type=template&id=4e99bcd5"
import script from "./KnowingUs.vue?vue&type=script&lang=js"
export * from "./KnowingUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports